{
  "hero": {
    "kicker": "✨ GRADELYNK PEER MENTORSHIP",
    "headline_kinetic": "Get Your Teen Into Top Canadian Universities Without the Tutoring Burnout.",
    "headline_aurora": "Master STEM & Neuroscience with Elite McMaster Scholars.",
    "subtext_rule_formula": "We pair your Grade 10-12 student with relatable university scholars who aced the exact same competitive programs. Through neuroscience active recall and STEM problem-solving frameworks, we turn study anxiety into 90%+ admissions averages.",
    "cta_primary": "Call Kian Now: +1 (437) 438-2820",
    "cta_secondary": "Book Free 15-Min Strategy Session",
    "risk_reversal_line": "✓ 100% Free 15-Min Diagnostic • No Obligation • Speak Directly with an Active Scholar"
  },
  "kian_section": {
    "title": "About the Founder: Kian",
    "degree": "B.Sc. Candidate in Psychology, Neuroscience & Behaviour at McMaster University",
    "about": "Currently pursuing a Bachelor of Science in Psychology, Neuroscience & Behaviour at McMaster University—widely recognized as one of the most rigorously competitive science programs in Canada—I bring a deep, academic foundation to my teaching.",
    "track_record": "I founded GradeLynk to help students bridge the gap between high school and university expectations. Since then, I have personally mentored over 35+ students into top programs.",
    "specializations": ["Grade 11 & 12 Math (Functions, Calculus)", "Grade 11 & 12 Chemistry", "Elementary & High School English", "SAT & Entrance Exam Strategy"]
  }
}
